module.exports = __webpack_public_path__ + "img/thumb-hm4.aa7f37b5.png";